import React, { useEffect, useState } from "react"; 
import {
  Grid,
  TextField,
  Typography,
  Card,
  CardContent,
  Button,
  Snackbar,
  Alert,
  useMediaQuery,
  useTheme,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from "@mui/material";
import { getDoc, doc, deleteDoc, setDoc } from "firebase/firestore";
import { db } from "../../../firebase";
import { useLocation } from "react-router-dom";

const AppointmentRequestFullView = () => {
  const [openModal, setOpenModal] = useState(false);
  const [data, setData] = useState({
    address: "",
    age: "",
    appointmentDate: "",
    appointmentTime: "",
    city: "",
    clinicId: "",
    clinicName: "",
    doctorId: "",
    geohash: "",
    id: "",
    patientName: "",
    phone: "",
    referenceCode: "",
    status: "",
    timestamp: 0,
    title: "",
    file: "",
    tokenNo: "",
    typeOfService: "",
    userId: "",
    whatsappNo: "",
  });
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("success");
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [deleteConfirmation, setDeleteConfirmation] = useState("");
  const [newStatus, setNewStatus] = useState("");
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const uid = params.get("uid");
    if (uid) {
      fetchData(uid);
    }
  }, [location.search]);

  const fetchData = async (uid) => {
    try {
      const docRef = doc(db, "appointmentrequest", uid);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        setData(docSnap.data());
      } else {
        console.log("No such document!");
      }
    } catch (error) {
      console.error("Error fetching document:", error);
    }
  };

  const handleDelete = async () => {
    try {
      const uid = data.id;
      await deleteDoc(doc(db, "appointmentrequest", uid));
      setAlertSeverity("success");
      setAlertMessage("Appointment request deleted successfully!");
      setData({
        address: "",
        age: "",
        appointmentDate: "",
        appointmentTime: "",
        city: "",
        clinicId: "",
        clinicName: "",
        doctorId: "",
        geohash: "",
        id: "",
        patientName: "",
        phone: "",
        referenceCode: "",
        status: "",
        timestamp: 0,
        title: "",
        file: "",
        tokenNo: "",
        typeOfService: "",
        userId: "",
        whatsappNo: "",
      });
      handleDeleteDialogClose();
    } catch (err) {
      console.error("Error deleting appointment request:", err);
      setAlertSeverity("error");
      setAlertMessage(`Error: ${err.message}`);
    } finally {
      setShowAlert(true);
    }
  };

  const handleDeleteDialogOpen = () => {
    setShowDeleteDialog(true);
  };

  const handleDeleteDialogClose = () => {
    setShowDeleteDialog(false);
    setDeleteConfirmation("");
  };

  const handleDeleteConfirmationChange = (e) => {
    setDeleteConfirmation(e.target.value);
  };

  const handleAlertClose = () => {
    setShowAlert(false);
  };

  const handleStatusUpdate = async () => {
    try {
      const uid = data.id;
      await setDoc(
        doc(db, "appointmentrequest", uid),
        { ...data, status: newStatus },
        { merge: true }
      );
      setAlertSeverity("success");
      setAlertMessage("Status updated successfully!");
      setShowAlert(true);
    } catch (error) {
      console.error("Error updating status:", error);
      setAlertSeverity("error");
      setAlertMessage(`Error: ${error.message}`);
      setShowAlert(true);
    }
  };

  const handlePreview = () => {
    if (data.file) {
      window.open(data.file, "_blank");
    }
  };

  return (
    <div className="App">
      <main style={{ padding: isMobile ? "10px 5px" : "20px 5px" }}>
        <Grid container justifyContent="center">
          <Grid item xs={12} sm={10} md={8} lg={6}>
            <Card style={{ margin: "0 auto" }}>
              <CardContent>
                <Typography
                  variant="h6"
                  color="#272727"
                  align="center"
                  gutterBottom
                >
                  Appointment Request Details
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      label="Patient Name"
                      name="patientName"
                      value={data.patientName || ""}
                      fullWidth
                      variant="outlined"
                      disabled
                    />
                    <TextField
                      label="Phone"
                      name="phone"
                      value={data.phone || ""}
                      fullWidth
                      variant="outlined"
                      style={{ marginTop: "16px" }}
                      disabled
                    />
                    <TextField
                      label="Age"
                      name="age"
                      value={data.age || ""}
                      fullWidth
                      variant="outlined"
                      style={{ marginTop: "16px" }}
                      disabled
                    />
                    <TextField
                      label="Address"
                      name="address"
                      value={data.address || ""}
                      fullWidth
                      variant="outlined"
                      style={{ marginTop: "16px" }}
                      disabled
                    />
                    <TextField
                      label="City"
                      name="city"
                      value={data.city || ""}
                      fullWidth
                      variant="outlined"
                      style={{ marginTop: "16px" }}
                      disabled
                    />
                    <TextField
                      label="Clinic Name"
                      name="clinicName"
                      value={data.clinicName || ""}
                      fullWidth
                      variant="outlined"
                      style={{ marginTop: "16px" }}
                      disabled
                    />
                    <TextField
                      label="Doctor ID"
                      name="doctorId"
                      value={data.doctorId || ""}
                      fullWidth
                      variant="outlined"
                      style={{ marginTop: "16px" }}
                      disabled
                    />
                    <TextField
                      label="Appointment Date"
                      name="appointmentDate"
                      value={data.appointmentDate || ""}
                      fullWidth
                      variant="outlined"
                      style={{ marginTop: "16px" }}
                      disabled
                    />
                    <TextField
                      label="Appointment Time"
                      name="appointmentTime"
                      value={data.appointmentTime || ""}
                      fullWidth
                      variant="outlined"
                      style={{ marginTop: "16px" }}
                      disabled
                    />
                    <TextField
                      label="Status"
                      name="status"
                      value={data.status || ""}
                      fullWidth
                      variant="outlined"
                      style={{ marginTop: "16px" }}
                      disabled
                    />
                    <TextField
                      label="Token No"
                      name="tokenNo"
                      value={data.tokenNo || ""}
                      fullWidth
                      variant="outlined"
                      style={{ marginTop: "16px" }}
                      disabled
                    />
                    <TextField
                      label="Type of Service"
                      name="typeOfService"
                      value={data.typeOfService || ""}
                      fullWidth
                      variant="outlined"
                      style={{ marginTop: "16px" }}
                      disabled
                    />
                    <TextField
                      label="File"
                      name="file"
                      value={data.file || ""}
                      fullWidth
                      variant="outlined"
                      style={{ marginTop: "16px" }}
                      disabled
                    />
                    {data.file && (
                      <>
                        {data.file.endsWith('.pdf') && (
                          <Button 
                            variant="contained" 
                            color="primary" 
                            onClick={handlePreview} 
                            style={{ marginTop: "16px" }}
                          >
                            Preview PDF
                          </Button>
                        )}
                        <img
                          src={data.file}
                          alt="Uploaded File"
                          style={{ marginTop: "16px", maxWidth: "100%", height: "auto" }}
                        />
                      </>
                    )}
                  </Grid>
                  <Grid container justifyContent="center">
                    <Grid item>
                      <FormControl
                        fullWidth
                        variant="outlined"
                        style={{ marginTop: "16px", width: "200px" }}
                      >
                        <InputLabel>Status</InputLabel>
                        <Select
                          value={newStatus}
                          onChange={(e) => setNewStatus(e.target.value)}
                          label="Status"
                        >
                          <MenuItem value="Pending">Pending</MenuItem>
                          <MenuItem value="Approved">Approved</MenuItem>
                          <MenuItem value="Rejected">Rejected</MenuItem>
                        </Select>
                      </FormControl>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleStatusUpdate}
                        style={{ marginTop: "16px", marginLeft: "8px" }}
                      >
                        Update Status
                      </Button>
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={handleDeleteDialogOpen}
                        style={{ marginTop: "16px", marginLeft: "8px" }}
                      >
                        Delete Request
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </main>
      <Snackbar
        open={showAlert}
        autoHideDuration={6000}
        onClose={handleAlertClose}
      >
        <Alert onClose={handleAlertClose} severity={alertSeverity}>
          {alertMessage}
        </Alert>
      </Snackbar>
      <Dialog
        open={showDeleteDialog}
        onClose={handleDeleteDialogClose}
      >
        <DialogTitle>Delete Appointment Request</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Type "DELETE" to confirm.
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            label="Confirmation"
            type="text"
            fullWidth
            variant="outlined"
            value={deleteConfirmation}
            onChange={handleDeleteConfirmationChange}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteDialogClose} color="primary">
            Cancel
          </Button>
          <Button
            onClick={handleDelete}
            color="secondary"
            disabled={deleteConfirmation !== "DELETE"}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AppointmentRequestFullView;
